import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import { MatTabsModule } from "@angular/material/tabs";
import { Tab } from "../../../interfaces/tab";
import { TabChange } from "../../../interfaces/tab-change";
import { CommonModule } from "@angular/common";
@Component({
  selector: "tabs",
  standalone: true,
  imports: [MatTabsModule, CommonModule],
  templateUrl: "./tabs.component.html",
  styleUrls: ["./tabs.component.scss"],
})
export class TabsComponent implements OnInit {
  @Input() tabs: Tab[] = [];
  @Input() stretch = false;
  @Input() selectedIndex = 0;
  @Output() tabChange = new EventEmitter<TabChange>();

  constructor() {}

  ngOnInit() {}

  onTabChange(selectedIndex: number) {
  this.tabChange.emit({ from: this.selectedIndex, to: selectedIndex });
}
}
